import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        // dark: true,
        themes: {
            dark: {
                primary: '#F36F2E',
                secondary: '#F7F7F7',
                accent: '#3c3c3c',
                error: '#8B0000',
                info: '#2196F3',
                success: '#228B22',
                warning: '#FFC107'
            },
            light: {
                primary: '#F36F2E',
                secondary: '#F7F7F7',
                accent: '#3c3c3c',
                error: '#8B0000',
                info: '#2196F3',
                success: '#228B22',
                warning: '#FFC107'
            },

        }
    }
});
